<div class="container">
  <a class="btn custom-button" [href]="instagramAuthUrl">
    <svg class="instagram-icon mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" height="20px">
      <path
        d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z" />
    </svg>
    Instagram Connect
  </a>

  <!-- Display OAuth tokens -->
  <div *ngIf="isLoading">
    <div *appSpinner="isLoading; message: 'Loading tokens...'"></div>
  </div>

  <div *ngIf="error">{{ error }}</div>

  <table *ngIf="!isLoading && oauthTokens.length > 0">
    <caption style="text-align:top">Auth Tokens:</caption>
    <thead>
      <tr>
        <th>Token ID</th>
        <th>Name</th>
        <th>Expires At</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let token of oauthTokens">
        <td>{{ token.id }}</td>
        <td>{{ token.name }}</td>
        <td>{{token.expiresAt | date:'dd.MM.yyyy HH:mm' }}</td>
        <td>
          <button (click)="showDialogDeleteToken(tokenDelete, token)" class="custom-button">
            <span><i class="fa fa-trash"></i></span> Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="oauthTokens.length === 0 && !isLoading" class="mt-3">
    <p>No OAuth tokens available.</p>
  </div>
</div>

<!-- Delete Modal -->
<ng-template #tokenDelete let-c="close" let-d="dismiss">
  <div class="backdrop-content">
    <div class="modal-body">
      <p>Are you sure want delete {{token.name}}, with id: {{token.id}}?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="c('No click')">Close</button>
      <button type="button" class="btn btn-danger" (click)="deleteToken(token.id)">Delete</button>
    </div>
  </div>
</ng-template>